module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/lodash-cherry-pick-loader.js!../../../../../../biz-b2c-web-h5/config/loader/yofo-cherry-pick-loader.js??ref--1-0!./index.tsx"));
	}, "DreamPlanView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DreamPlanView!../biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/home/index.tsx
// module id = 1106
// module chunks = 431